/** @file frameAnimKey: a default frame animation's key at a node's own 60 Hz tick counter (21.2). */
import type { FrameAnimLoop } from '@zilo/pose3d-pose/time/timeTypes';

/**
 * Design 21.2: `i = floor(ticks / hold)`; `frames[i]` while `i < loopStart`, else
 * `frames[loopStart + (i - loopStart) mod (length - loopStart)]`. Negative ticks count as 0, `hold` below 1 as 1,
 * `loopStart` is clamped into the frames; an empty animation gives 0.
 */
export function frameAnimKey(anim: FrameAnimLoop, ticks: number): number {
  const len = anim.frames.length;
  if (len === 0) return 0;
  const i = Math.floor(Math.max(0, ticks) / Math.max(1, anim.hold));
  const loopStart = Math.min(Math.max(0, Math.floor(anim.loopStart ?? 0)), len - 1);
  return anim.frames[i < loopStart ? i : loopStart + ((i - loopStart) % (len - loopStart))] ?? 0;
}
